import favicon from '@resources/images/favicon.png';
import VFileLogo from '@resources/svgs/logos/vFile_logo.svg';
import VSuiteLogo from '@resources/svgs/logos/vSuite_logo.svg';
import { vfileRoutes } from '@routes/vfile';
import { vsuiteRoutes } from '@routes/vsuite';

import type { ExtendedAppConfig } from '../baseConfig';

export const vsuiteConfig: ExtendedAppConfig = {
  company: {
    address: '1st Floor, Omni House, 252 Belsize Road, London, NW6 4BT, United Kingdom',
    name: 'vatglobal',
    registeredCountry: 'United Kingdom',
    registeredName: 'VAT Compliance Europe Limited t/a vatglobal',
  },
  favicon,
  helpUrl: 'https://help.myvsuite.com/',
  legalEmail: 'legal@vatglobal.com',
  signUpUrl: 'https://www.vatglobal.com/vsuite',
  supportEmail: 'support@myvsuite.com',
  contractualClausesUrl: 'https://www.vatglobal.com/standard-contractual-clauses',
  vfile: {
    logo: VFileLogo,
    name: 'vfile',
    url: vfileRoutes.FILING_LIST.make(),
  },
  vsuite: {
    logo: VSuiteLogo,
    name: 'vsuite',
    url: vsuiteRoutes.DASHBOARD.make(),
  },
};
